import React, { createContext } from 'react'

export const LanguageContext = createContext(null);